/**
 * Thousands separators on a money input.
 *
 * A limit is typed and read as digits, so ₦1000000 has to be counted zero by
 * zero to know what it says — and a mistyped one looks exactly like a correct
 * one. Only the display is grouped; the value stays a plain number, and what
 * is sent is unchanged.
 */

const GROUP_EVERY_THREE = /\B(?=(\d{3})+(?!\d))/g;

export function formatMoneyInput(value?: string | number | null): string {
  if (value === undefined || value === null || value === "") {
    return "";
  }

  const [whole, fraction] = `${value}`.split(".");
  const grouped = whole.replace(GROUP_EVERY_THREE, ",");

  return fraction === undefined ? grouped : `${grouped}.${fraction}`;
}

export function parseMoneyInput(display?: string): string {
  return display ? display.replace(/,/g, "") : "";
}

/** Spread onto any `InputNumber` holding an amount. */
export const MONEY_INPUT = {
  formatter: formatMoneyInput,
  parser: parseMoneyInput,
};
